/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileImage: {
  name: 'file-image';
  data: string;
} = {
  name: 'file-image',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 2A1.5 1.5 0 0 1 4 .5h4.586a1.5 1.5 0 0 1 1.06.44l3.415 3.414a1.5 1.5 0 0 1 .439 1.06V14a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 14V2Zm10 3.5V11L9.3 8.6a.5.5 0 0 0-.577-.016L3.5 12.066V2a.5.5 0 0 1 .5-.5h4.5V4A1.5 1.5 0 0 0 10 5.5h2.5Zm-.707-1L9.5 2.207V4a.5.5 0 0 0 .5.5h1.793ZM3.5 14v-.732l5.483-3.656L12.5 12.25V14a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5ZM6 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
